module.exports = __webpack_public_path__ + "img/factoryCase1.2fc61b51.jpg";